<!--
Created by Dmytro Sav. on 5/18/2020
Copyright © 2020 Curriculum Ltd. All rights reserved.
-->
<div class="curr-tutorial-session-question">
<!--  <h3 class="title" [currMath]="title"></h3>-->
<!--  <curr-breadcrumb [position]="'start'" [path]="path" position="center" class="m-t-40 m-b-24"></curr-breadcrumb>-->
  <div class="wrapper">
    <div fxLayout="column" class="correct-answer">
      <mat-card fxLayout="column" class="correct-answer-card">
        <div class="mat-h4" fxLayoutAlign="space-between center">
          <div fxLayout fxLayoutAlign="center center">
<!--            <div class="circle m-r-16" *ngIf="!isCtTest" [ngClass]="ctItem.is_correct ? 'correct-circle' : 'incorrect-circle'"></div>-->
<!--            <div class="circle circle-ct m-r-16" *ngIf="isCtTest" [ngClass]="ctItem.is_correct ? 'correct-circle-ct' : 'incorrect-circle'">-->
<!--              <span>{{ ctItem.mark }}</span>-->
<!--            </div>-->
            <div class="mat-body-1 question-wording" *ngIf="!ctItem.previewQuestion"
                 [currMath]="ctItem.question || 'No Question Introduction'"></div>
            <div class="mat-body-1 question-wording" *ngIf="ctItem.previewQuestion"
                 [currMath]="ctItem.previewQuestion || 'No Question Introduction'"></div>
          </div>
<!--          <mat-icon svgIcon="arrow-circle" class="arrow" (click)="ctItem.isOpen = !ctItem.isOpen" [ngClass]="{ 'opened': ctItem.isOpen }"></mat-icon>-->
<!--          &lt;!&ndash;      <ng-container *ngIf="isCtTest">&ndash;&gt;-->
<!--          &lt;!&ndash;        <span class="marks mat-caption" *ngIf="ctItem.answer_type !== questionType.MULTIPART">{{ ctItem.result_mark }}&ndash;&gt;-->
<!--          &lt;!&ndash;          marks</span>&ndash;&gt;-->
<!--          &lt;!&ndash;      </ng-container>&ndash;&gt;-->
        </div>
        <div [@grow]>
          <div *ngIf="ctItem.answer_type !== questionType.MULTIPART" fxLayout="row" fxLayoutAlign="space-between flex-start" class="question-info">
            <ng-container *ngTemplateOutlet="yourAnswer;context: {q:ctItem}"></ng-container>
<!--            <ng-container *ngTemplateOutlet="correctAnswer;context: {q:ctItem}"></ng-container>-->
          </div>

          <ng-container *ngIf="ctItem.answer_type == questionType.MULTIPART">
            <ng-container *ngTemplateOutlet="multipartQuestion;context: {q:ctItem, st: (1)}"></ng-container>
          </ng-container>

          <ng-container *ngTemplateOutlet="replyFromTeacher;context: {q:ctItem}"></ng-container>

          <!--      <div class="hint" *ngIf="!ctItem.is_correct">-->
          <!--        <mat-icon class="icon" color="primary" svgIcon="exclamation-mark" [inline]="true"></mat-icon>-->
          <!--        Please review Topic Resources <a class="link" (click)="goToLR(ctItem)">here</a> to improve your understanding.-->
          <!--      </div>-->

<!--          <div fxLayoutAlign="end" *ngIf="getIsPlayVideoAvailable(ctItem)" class="answer-btn-container">-->
<!--            &lt;!&ndash; View explanation video btn &ndash;&gt;-->
<!--            <curr-button variant="contained" size="big" (btnClick)="viewExplanationVideo(ctItem)" class="video-btn">-->
<!--              <mat-icon>play_arrow</mat-icon>-->
<!--              Watch explanation video-->
<!--            </curr-button>-->
<!--          </div>-->
          <div class="additional" *ngIf="ctItem.hint">Hint: &nbsp;<span class="additional-info" [currMath]="ctItem.hint"></span></div>
          <div class="additional" *ngIf="ctItem.video_url">Explanation: &nbsp;<span class="additional-info" [currMath]="ctItem.video_url"></span></div>
        </div>
      </mat-card>
    </div>
<!--    <curr-topic-test-widget class="widget"></curr-topic-test-widget>-->
  </div>
</div>


<ng-template #multipartQuestion let-question="q" let-start="st">
  <div fxLayout="column" fxLayoutAlign="start stretch" class="full-width"
       *ngFor="let q of question.children;let i = index">
    <ng-container *ngIf="q.children.length">
      <div fxLayout="row">
        <span class="mat-h4 your-answer-title m-r-8 m-b-0">{{start + '.' + (i + 1)}}</span>
        <div class="mat-body-1 question-wording m-b-24" *ngIf="!q.previewQuestion"
             [currMath]="q.question || 'No Question Introduction'"></div>
        <div class="mat-body-1 question-wording m-b-24" *ngIf="q.previewQuestion"
             [currMath]="q.previewQuestion || 'No Question Introduction'"></div>
      </div>
      <div class="block-container full-width m-b-24" fxLayout="column" fxLayoutAlign="start stretch">
        <ng-container *ngFor="let subq of q.children;let j = index">
          <ng-container *ngTemplateOutlet="oneMultipartQuestion;
         context: {q:subq,
                   st: start + '.' + (i+1)+ '.' + (j+1),
                   last: (j+1) == q.children.length}"></ng-container>
        </ng-container>
      </div>
    </ng-container>
    <ng-container *ngIf="!q.children.length">
      <ng-container *ngTemplateOutlet="oneMultipartQuestion;
      context: {q:q, st: start + '.' + (i+1)}"></ng-container>
    </ng-container>
  </div>

</ng-template>

<ng-template #oneMultipartQuestion let-que="q" let-start="st" let-lst="last">
  <div class="full-width ">
    <div fxLayout="row" fxLayoutAlign="space-between start" class="full-width">
      <div fxLayout="column" class="full-width">
        <div fxLayout="row" fxLayoutAlign="space-between start">
          <div fxLayout="row">
            <span class="mat-h4 your-answer-title m-r-8">{{start}}</span>
            <div class="mat-body-1 question-wording m-b-24" *ngIf="!que.previewQuestion"
                 [currMath]="que.question || 'No Question Introduction'"></div>
            <div class="mat-body-1 question-wording m-b-24" *ngIf="que.previewQuestion"
                 [currMath]="que.previewQuestion || 'No Question Introduction'"></div>
          </div>
          <ng-container *ngIf="isCtTest">
            <span class="marks mat-caption">{{ que.result_mark || 0 }} marks</span>
          </ng-container>
        </div>

        <ng-container *ngTemplateOutlet="yourAnswer;context: {q:que}"></ng-container>
        <ng-container *ngTemplateOutlet="correctAnswer;context: {q:que}"></ng-container>
        <ng-container *ngTemplateOutlet="replyFromTeacher;context: {q:que}"></ng-container>

      </div>


    </div>
    <mat-divider class="disable-absolute" [ngClass]="lst ? '': 'm-b-24'"></mat-divider>
  </div>
</ng-template>

<ng-template #yourAnswer let-ctItem="q">
  <div fxLayout="column">
    <div class="row row-block" *ngIf="questionType.OPEN_ENDED == ctItem.answer_type">
      <div class="test-question-view">
        <div class="test-question-view-row" *ngIf="!isOpenAnswer() && ctItem.children.length === 0">
          <div>
            <div class="view-row-title">Mark Scheme:</div>
            <div class="open-ended-answers">
              <div class="open-ended-answers-row" *ngFor="let keyword of ctItem.oeq_keywords; let i = index">
                <div class="open-ended-cell open-ended-answer">
                  <div class="open-ended-title">Answer</div>
                  <div class="open-ended-desc" [currMath]="keyword.key"></div>
                </div>
                <div class="open-ended-cell open-ended-mark">
                  <div class="open-ended-title">Mark</div>
                  <div class="open-ended-desc">{{ keyword.mark }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="test-question-view-row">
        <div class="view-row-title total-available-marks">Total Available Marks: <span class="mark-value">{{ ctItem.mark }}</span></div>
      </div>
    </div>

    <div class="mat-h4 your-answer-title answer m-b-7" *ngIf="questionType.OPEN_ENDED != ctItem.answer_type">Answers:</div>
    <div class="column" [ngSwitch]="true" *ngIf="questionType.OPEN_ENDED != ctItem.answer_type">
      <div class="row" *ngFor="let item of ctItem.answer_options; let i = index">
        <div class="circle-question m-r-16"  [ngClass]="i === ctItem.correct_answer_options[0] ? 'correct-circle' : 'incorrect-circle'"></div>
        <div fxLayout="column" class="m-b-16 mat-h4"
             [ngClass]="i === ctItem.correct_answer_options[0] ? 'your-answer-correct' : 'your-answer-wrong'">
          <ng-container *ngSwitchCase="isMultiVariants(ctItem)">
            <span [currMath]="item"></span>
          </ng-container>

          <ng-container *ngSwitchCase="ctItem.answer_type === questionType.FILE_INPUT">
            <img [src]="ctItem.student_answer_file" alt="" />
          </ng-container>

          <ng-container *ngSwitchCase="ctItem.answer_type === questionType.OPEN_ENDED">
            <div [currMath]="ctItem.student_answer_text || ctItem.answer_solution || 'No data'"></div>
            <!--        <div [innerHTML]="ctItem.answer_solution"></div>-->
          </ng-container>

          <ng-container *ngSwitchCase="ctItem.answer_type === questionType.SINGLE_ANSWER">
            <span [currMath]="ctItem.student_answer_text || ctItem.answer_solution || 'No data'"></span>
          </ng-container>
          <!--      <ng-container *ngSwitchCase="ctItem.answer_type === questionType.TRUE_OR_FALSE">-->
          <!--        <span [innerHTML]="ctItem.answer_options[ctItem.student_correct_answer_options[0]] || 'No data'"></span>-->
          <!--      </ng-container>-->
          <!--      <ng-container *ngSwitchCase="ctItem.answer_type === questionType.SELECT_ONE">-->
          <!--        <span [innerHTML]="ctItem.answer_options[ctItem.student_correct_answer_options[0]] || 'No data'"></span>-->
          <!--      </ng-container>-->
          <!--      <ng-container *ngSwitchCase="ctItem.answer_type === questionType.SELECT_MULTIPLE">-->
          <!--        <span   *ngFor="let studCorOpt in ctItem.student_correct_answer_options"-->
          <!--          [innerHTML]="ctItem.answer_options[studCorOpt] || 'No data'"></span>-->
          <!--        <span *ngIf="!ctItem.student_correct_answer_options.length">No data</span>-->
          <!--      </ng-container>-->
        </div>
      </div>
    </div>
  </div>
</ng-template>


<ng-template #correctAnswer let-ctItem="q">
  <ng-container>

    <ng-container *ngIf="isMultiVariants(ctItem)">
      <div fxLayout="column">
        <div class="mat-h4 correct-title answer m-b-7">Right answer:</div>
        <div class="p-b-8 mat-h4 your-answer-correct">

          <ng-container *ngIf="ctItem.answer_type === questionType.TRUE_OR_FALSE">
            <span [currMath]="ctItem.answer_options[ctItem.correct_answer_options[0]] || 'No data'"></span>
          </ng-container>
          <ng-container *ngIf="ctItem.answer_type === questionType.SELECT_ONE">
            <span [currMath]="ctItem.answer_options[ctItem.correct_answer_options[0]] || 'No data'"></span>
          </ng-container>
          <ng-container *ngIf="ctItem.answer_type === questionType.SELECT_MULTIPLE">
            <span *ngFor="let studCorOpt in ctItem.correct_answer_options"
                  [currMath]="ctItem.answer_options[studCorOpt] || 'No data'"></span>
            <span *ngIf="!ctItem.correct_answer_options.length">No data</span>
          </ng-container>
        </div>
        <div *ngIf="ctItem.cou" class="p-b-8 mat-h4 ">
          <div>Question (COU):</div>
          <div>{{ ctItem.cou }}</div>

          <div>My response Question:</div>
          <div></div>
        </div>
      </div>
    </ng-container>
  </ng-container>

</ng-template>


<ng-template #replyFromTeacher let-ctItem="q">
  <div class="teacher-comment m-b-24" *ngIf="ctItem.text_answer || ctItem.audio_answer_file">
    <div class="mat-h4 correct-title m-b-0">Reply from teacher:</div>
    <audio controls *ngIf="ctItem.audio_answer_file">
      <source [src]="ctItem.audio_answer_file" type="audio/webm" />
    </audio>
    <span class="mat-body-1" *ngIf="ctItem.text_answer" [currMath]="ctItem.text_answer"></span>
  </div>
</ng-template>
